module.exports = __webpack_public_path__ + "static/media/15.7c06903d.jpg";